export const RedirectToSource = (row: any, history: any) => {
  const url = row.article_link;
  window?.open(url, "_blank")?.focus();
};
